import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { TellentAdoptedStylesheetsDirective, TellentThemeDirective } from '@core/tellent-smart-ui';
import { TELLENT_CLIENT_CONFIG, TellentClientConfig } from '@core/tellent-types';

@Component({
  selector: 'x-shadow-overlay-container-root',
  standalone: true,
  template: `<div #root class="cdk-overlay-container"></div>`,
  hostDirectives: [TellentThemeDirective, TellentAdoptedStylesheetsDirective],
  styleUrls: ['../../../../styles.less'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShadowOverlayContainerRootComponent {
  public elRef = inject(ElementRef);
  public config = inject(TELLENT_CLIENT_CONFIG);

  @ViewChild('root', { static: true, read: ElementRef }) public root: ElementRef<HTMLDivElement>;

  public ngOnInit() {
    this.addConfiguredStyles();
  }

  private addConfiguredStyles() {
    const shadowRoot: ShadowRoot = this.elRef.nativeElement.shadowRoot;
    const sheet = new CSSStyleSheet();

    const styles: string[] = [];

    styles.push(...this.createOverlayStyles(this.config.ui));

    sheet.replaceSync(styles.join('\n'));

    shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, sheet];
  }

  private createOverlayStyles(ui: TellentClientConfig['ui']) {
    if (!ui) return [];

    const styles = [];

    if (ui && ui.overlayContainerZIndex) {
      styles.push(`
      .cdk-overlay-container {
        z-index: ${ui.overlayContainerZIndex};
      }
      `);
    }
    if (ui && ui.overlayZIndex) {
      styles.push(`
      .cdk-overlay-connected-position-bounding-box,
      .cdk-global-overlay-wrapper,
      .cdk-overlay-pane {
        z-index: ${ui.overlayZIndex};
      }
      `);
    }
    if (ui && ui.overlayBackdropZIndex) {
      styles.push(`
      .cdk-overlay-container {
        z-index: ${ui.overlayBackdropZIndex};
      }
      `);
    }

    return styles;
  }
}
